var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VView',{staticClass:"gallery-item",attrs:{"back-button-to":"/gallery","header":_vm.$t('gallery.header')}},[_c('VMedia',{staticClass:"gallery-item__frame"},[_c('img',{attrs:{"src":_vm.$route.query.url}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }